{
  "markread": "Markera som läst",
  "newest": "Nyast",
  "unread": "Oläst",
  "starred": "Stjärnmärkta",
  "tags": "Taggar",
  "alltags": "Alla taggar",
  "timestamp": "{0,date} {0,time}",
  "hours": "för {0,plural,one {1 timme},other {# timmar}} sedan",
  "minutes": "för {0,plural,one {1 minut},other {# minuter}} sedan",
  "seconds": "för {0,plural,one {1 sekund},other {# sekunder}} sedan",
  "days": "{0,plural,zero {idag},one {igår},other {för # dagar sedan}}",
  "star": "Stjärnmärk",
  "unstar": "Ta bort stjärnmärkning",
  "mark": "Markera som läst",
  "unmark": "Markera som oläst",
  "load_img": "Läs in bilder",
  "open_window": "Öppna i nytt fönster",
  "searchbutton": "Sök",
  "sources": "Källor",
  "source_add": "Lägg till källa",
  "source_opml": "eller importera från en OPML-fil eller Google Reader",
  "source_edit": "Redigera",
  "source_delete": "Ta bort",
  "source_warn": "Vill du verkligen ta bort källan?",
  "source_new": "Ny källa",
  "source_title": "Titel",
  "source_tags": "Taggar",
  "source_comma": "Kommaseparerade",
  "source_select": "Välj källa",
  "source_type": "Typ",
  "source_save": "Spara",
  "source_cancel": "Avbryt",
  "source_saved": "Källan har sparats",
  "no_entries": "Inga inlägg hittades",
  "more": "Fler",
  "login": "Logga in",
  "login_username": "Användarnamn",
  "login_password": "Lösenord",
  "source_last_post": "Senaste inlägg",
  "filter": "Filter",
  "online_count": "Inlägg tillgängliga på servern",
  "offline_count": "Inlägg tillgängliga lokalt",
  "next": "Nästa",
  "searchremove": "Dölj sökningen",
  "refreshbutton": "Uppdatera källorna",
  "settingsbutton": "Inställningar",
  "logoutbutton": "Logga ut",
  "loginbutton": "Logga in",
  "source_export": "Exportera källor",
  "source_filter": "Filter",
  "source_autotitle_hint": "Lämna tomt för att hämta titeln",
  "source_pwd_placeholder": "Oförändrat",
  "source_refresh": "Uppdatera källan",
  "login_invalid_credentials": "Felaktigt användarnamn eller lösenord",
  "login_offline": "Offlinelagring",
  "no_title": "Ingen titel",
  "error": "Ett fel uppstod",
  "streamerror": "Inga inlägg lästes in. Läsa in igen?",
  "reload_list": "Ladda om listan",
  "sources_refreshed": "Källorna har uppdaterats",
  "app_update": "selfoss har uppdaterats. Läs in sidan igen.",
  "app_reload": "Ladda om",
  "error_session_expired": "Sessionen har gått ut",
  "error_add_source": "Det gick inte att lägga till källan:",
  "error_delete_source": "Det gick inte att ta bort källan:",
  "error_load_tags": "Det gick inte att läsa in taggarna:",
  "error_unknown_tag": "Okänd tagg:",
  "error_unknown_source": "Okänt käll-ID:",
  "error_mark_items": "Det gick inte att markera alla synliga inlägg:",
  "error_mark_item": "Det gick inte att markera eller avmarkera inlägget:",
  "error_star_item": "Det gick inte att stjärnmärka inlägget eller ta bort dess stjärnmärkning:",
  "error_logout": "Det gick inte att logga ut:",
  "error_loading": "Fel vid inläsning:",
  "error_loading_stats": "Det gick inte att läsa in navigeringsstatistiken:",
  "error_saving_color": "Det gick inte att spara den nya färgen:",
  "error_refreshing_source": "Det gick inte att uppdatera källan:",
  "error_sync": "Det gick inte att synkronisera de senaste ändringarna från servern:",
  "error_offline_storage": "Fel i offlinelagringen: {0}. Det kan hjälpa att läsa in sidan igen. Offlineläget inaktiveras tillfälligt.",
  "error_invalid_subsection": "Ogiltigt underavsnitt:",
  "search_label": "Sökterm",
  "article_actions": "Åtgärder",
  "error_configuration": "Det gick inte att läsa in konfigurationen.",
  "info_url_copied": "URL:en har kopierats till urklipp.",
  "share_native_label": "Dela",
  "share_diaspora_label": "Dela på diaspora*",
  "share_twitter_label": "Dela på Twitter",
  "share_facebook_label": "Dela på Facebook",
  "share_pocket_label": "Spara i Pocket",
  "share_wallabag_label": "Spara i wallabag",
  "share_wordpress_label": "Dela på WordPress",
  "share_mail_label": "Dela via e-post",
  "share_copy_label": "Kopiera länk till urklipp",
  "error_share_native_abort": "Det gick inte att dela inlägget – det finns inga delningsmål eller så avbröts delningen.",
  "error_share_native": "Det gick inte att dela inlägget.",
  "close_entry": "Stäng inlägget",
  "experimental": "Experimentellt",
  "error_unwritable_logs": "Det gick inte att skriva till loggarna.",
  "error_check_system_logs": "Ett fel uppstod. Kontrollera systemloggarna.",
  "error_check_log_file": "Ett fel uppstod. Kontrollera loggfilen “{0}”.",
  "source_browse": "Bläddra",
  "tag_change_color_button_title": "Ändra färg",
  "source_warn_cancel_dirty": "Kasta osparade ändringar?",
  "offline_navigation_unavailable": "Det går för närvarande inte att byta tagg eller källa i offlineläge.",
  "sources_leaving_unsaved_prompt": "Vill du lämna inställningarna trots osparade ändringar i källorna?",
  "error_offline_storage_not_available": "Offlinelagring är inte tillgänglig. Kontrollera att webbläsaren {0}stöder IndexedDB-API:t{1} och, om du använder en Chromium-baserad webbläsare, att selfoss inte körs i inkognitoläge.",
  "error_edit_source": "Det gick inte att spara ändringarna i källan:",
  "source_menu": "Fler åtgärder",
  "no_sources": "Inga källor har konfigurerats.",
  "source_deleting": "Tar bort källan…",
  "login_error_generic": "Det gick inte att logga in: {errorMessage}",
  "sources_loading": "Läser in källor…",
  "source_params_loading": "Läser in parametrar…",
  "source_saving": "Sparar ändringar i källan…",
  "source_go_to_settings": "Öppna i inställningarna",
  "entries_loading": "Läser in inlägg…",
  "login_in_progress": "Loggar in…",
  "error_unauthorized": "{link_begin}Logga in{link_end} för att fortsätta.",
  "article_reading_time": "Lästid: {0} min",
  "share_mastodon_label": "Dela på Mastodon"
}
